import { createReducer, on } from '@ngrx/store';
import {
    Load,
    LoadAllLocations,
    LoadFail,
    LoadLocationsForBerthPlanner,
    LoadLocationsForBerthPlannerSuccess,
    LoadLocationsForNOA,
    LoadSuccess
} from '../actions/location.action';
import { ILocation, LocationForBerthPlanner } from '../model/location';
import { IQueryResult } from '@pmis3/data-access';

export const locationFeatureKey = 'location';

export enum LocationStateStatus {
    LOADING = 'loading',
    FAILED = 'failed',
    PENDING = 'pending',
    SUCCESS = 'success',
}
export interface LocationState {
    locations: IQueryResult<ILocation>;
    locationsForBerthPlanner: LocationForBerthPlanner[];
    error?: string;
    status: LocationStateStatus;
    locationsForNOA: ILocation[];
    terminalsForNOA: ILocation[];
}

export const initialState: LocationState = {
    locations: {
        query: { pageIndex: 0, pageSize: 0 },
        items: [],
        totalCount: 0,
    },
    locationsForBerthPlanner: [],
    status: LocationStateStatus.PENDING,
    locationsForNOA: [],
    terminalsForNOA: []
};

export const locationReducer = createReducer(
    initialState,
    on(Load, (state) => ({ ...state, status: LocationStateStatus.PENDING })),
    on(LoadAllLocations, (state) => ({
        ...state,
        status: LocationStateStatus.PENDING,
    })),
    // on(LoadLocationsForBerthPlanner, (state) => ({ ...state, locationsForBerthPlanner: LocationHelper.mapLocationToLocationForBerthPlanner(state.locations.items), status: LocationStateStatus.SUCCESS })),
    on(LoadLocationsForBerthPlanner, (state) => ({
        ...state,
        status: LocationStateStatus.PENDING,
    })),
    on(LoadSuccess, (state, { result: locations }) => ({
        ...state,
        locations,
        status: LocationStateStatus.SUCCESS,
    })),
    on(LoadLocationsForBerthPlannerSuccess, (state, { result: locations }) => ({
        ...state,
        locationsForBerthPlanner: locations,
        status: LocationStateStatus.SUCCESS,
    })),
    on(LoadFail, (state, { error }) => ({
        ...state,
        error,
        status: LocationStateStatus.FAILED,
    })),
    on(LoadLocationsForNOA, (state, { locations: locations, terminals: terminals}) => ({
        ...state,
        locationsForNOA: locations,
        terminals: terminals,
        status: LocationStateStatus.SUCCESS,
    })),
);
